
export default {
  props: ["path", "src", "name"],
};
